export default "__VITE_ASSET__BZVq1Vtd__"